import { PencilRulerIcon } from './PencilRulerIcon';

/**
 * author: Michael Irigoyen
 * id B8F0B132-5AD7-4E4B-ADDB-311FDBDD35CC
 * name pencil-ruler
 * version: 4.9.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/pencil-ruler.svg
 * tags
 * - Drawing / Art 
 */
export const DesignIcon = PencilRulerIcon;
export default DesignIcon